import type { BrokerOrgAddressSection } from './formFieldPaths';
import { addressField, orgAddressPath } from './formFieldPaths';

export type { BrokerOrgAddressSection } from './formFieldPaths';
export { brokerOrgFormRoot, isAddressManualPathFor, orgAddressValuePath } from './formFieldPaths';

export function addressFieldPathsFor(group: BrokerOrgAddressSection) {
  return {
    addressLine1: orgAddressPath(group, addressField.addressLine1),
    addressLine2: orgAddressPath(group, addressField.addressLine2),
    postcode: orgAddressPath(group, addressField.postcode),
    town: orgAddressPath(group, addressField.town),
    county: orgAddressPath(group, addressField.county),
    country: orgAddressPath(group, addressField.country),
  } as const;
}
